import { render, staticRenderFns } from "./controlPagination.vue?vue&type=template&id=00197696&scoped=true&"
import script from "./controlPagination.vue?vue&type=script&lang=js&"
export * from "./controlPagination.vue?vue&type=script&lang=js&"
import style0 from "./controlPagination.vue?vue&type=style&index=0&id=00197696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00197696",
  null
  
)

export default component.exports